import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { JsonLd } from '@/components/base/JsonLd';
import { categories, articles } from '@/mocks/news';

function buildCategoryBreadcrumb(categoryName: string, categorySlug: string) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: '首页',
        item: 'http://baiducc.cn/',
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: categoryName,
        item: `http://baiducc.cn/category/${categorySlug}`,
      },
    ],
  };
}

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);
  const filteredCategoryArticles = articles.filter((a) => a.category === slug);
  const categoryArticles = filteredCategoryArticles.length ? filteredCategoryArticles : articles;

  const articleImages: Record<string, string> = {
    '1': 'https://readdy.ai/api/search-image?query=Dramatic%20news%20scene%20with%20warm%20lighting%20and%20mysterious%20atmosphere%2C%20journalism%20concept%2C%20editorial%20photography%2C%20dark%20amber%20and%20charcoal%20tones%2C%20breaking%20news%20mood%2C%20professional%20composition&width=600&height=400&seq=cat-news-01&orientation=landscape',
    '2': 'https://readdy.ai/api/search-image?query=Gaming%20streaming%20setup%20in%20darkness%20with%20dramatic%20red%20neon%20lighting%2C%20editorial%20photography%2C%20mysterious%20atmosphere%2C%20warm%20dark%20tones%2C%20professional%20composition&width=600&height=400&seq=cat-news-02&orientation=landscape',
    '3': 'https://readdy.ai/api/search-image?query=Film%20set%20with%20director%20chair%20in%20spotlight%2C%20dramatic%20cinematic%20lighting%2C%20editorial%20photography%2C%20warm%20golden%20tones%2C%20behind%20the%20scenes%20atmosphere&width=600&height=400&seq=cat-news-03&orientation=landscape',
    '5': 'https://readdy.ai/api/search-image?query=Cosmetic%20products%20on%20dark%20surface%20under%20dramatic%20lighting%2C%20mysterious%20laboratory%20atmosphere%2C%20editorial%20photography%2C%20warm%20amber%20tones%2C%20investigative%20mood%2C%20professional%20composition&width=600&height=400&seq=cat-news-05&orientation=landscape',
    '6': 'https://readdy.ai/api/search-image?query=Two%20spotlights%20facing%20each%20other%20on%20dark%20stage%2C%20musical%20instruments%20in%20shadow%2C%20dramatic%20confrontation%2C%20editorial%20photography%2C%20warm%20golden%20tones%2C%20cinematic%20composition&width=600&height=400&seq=cat-news-06&orientation=landscape',
    '7': 'https://readdy.ai/api/search-image?query=Smartphone%20screen%20displaying%20messages%20in%20dark%20environment%2C%20dramatic%20moody%20lighting%2C%20editorial%20photography%2C%20warm%20amber%20tones%2C%20mysterious%20atmosphere%2C%20professional%20composition&width=600&height=400&seq=cat-news-07&orientation=landscape',
    '8': 'https://readdy.ai/api/search-image?query=Empty%20modern%20office%20with%20dim%20lighting%2C%20abandoned%20desks%2C%20corporate%20decline%2C%20editorial%20photography%2C%20warm%20dark%20tones%2C%20melancholic%20mood%2C%20professional%20composition&width=600&height=400&seq=cat-news-08&orientation=landscape',
    '9': 'https://readdy.ai/api/search-image?query=Luxury%20cosmetic%20products%20under%20magnifying%20glass%2C%20investigative%20atmosphere%2C%20editorial%20photography%2C%20warm%20golden%20tones%2C%20forensic%20mood%2C%20professional%20composition&width=600&height=400&seq=cat-news-09&orientation=landscape',
    '10': 'https://readdy.ai/api/search-image?query=Gaming%20setup%20with%20multiple%20monitors%20in%20dark%20room%2C%20dramatic%20neon%20lighting%2C%20esports%20atmosphere%2C%20editorial%20photography%2C%20warm%20red%20tones%2C%20professional%20composition&width=600&height=400&seq=cat-news-10&orientation=landscape',
    '11': 'https://readdy.ai/api/search-image?query=Smartphone%20camera%20lens%20with%20city%20street%20reflection%2C%20privacy%20concept%2C%20dramatic%20lighting%2C%20editorial%20photography%2C%20urban%20night%20mood%2C%20professional%20composition&width=600&height=400&seq=cat-news-11&orientation=landscape',
    '12': 'https://readdy.ai/api/search-image?query=Fashion%20design%20sketches%20on%20dark%20table%2C%20creative%20studio%2C%20dramatic%20warm%20lighting%2C%20editorial%20photography%2C%20artistic%20composition%2C%20professional%20mood&width=600&height=400&seq=cat-news-12&orientation=landscape',
  };

  if (!category) {
    return (
      <>
        <Navbar />
        <main className="min-h-screen flex items-center justify-center pt-16">
          <div className="text-center">
            <h1 className="text-2xl font-bold text-foreground-900 mb-2">分类不存在</h1>
            <Link to="/" className="text-accent-600 hover:underline text-sm">返回首页</Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  const topArticles = categoryArticles.slice(0, 3);
  const remainingArticles = categoryArticles.slice(3);

  return (
    <>
      <JsonLd data={buildCategoryBreadcrumb(category.name, category.slug)} />
      <Navbar />
      <main className="pt-20">
        {/* Breadcrumb */}
        <div className="px-4 md:px-6 py-4">
          <div className="max-w-7xl mx-auto">
            <nav aria-label="面包屑导航">
              <ol className="flex items-center gap-2 text-xs text-foreground-500">
                <li><Link to="/" className="hover:text-foreground-900 transition-colors">首页</Link></li>
                <li><i className="ri-arrow-right-s-line text-xs"></i></li>
                <li className="text-foreground-900 font-medium">{category.name}</li>
              </ol>
            </nav>
          </div>
        </div>

        {/* Hero Area */}
        <section className="relative w-full min-h-[280px] md:min-h-[360px] flex items-center justify-center overflow-hidden">
          <div className="absolute inset-0 bg-foreground-900"></div>
          <div className="absolute inset-0 bg-gradient-to-b from-foreground-900/80 to-foreground-900/95"></div>
          <div className="relative z-10 w-full max-w-4xl mx-auto text-center px-4 md:px-6">
            <div className="w-14 h-14 md:w-16 md:h-16 mx-auto flex items-center justify-center bg-accent-500/90 rounded-full mb-4">
              <i className={`${category.icon} text-2xl md:text-3xl text-background-50`}></i>
            </div>
            <h1 className="text-2xl md:text-5xl font-black font-heading text-background-50 mb-3">
              {category.name}
            </h1>
            <p className="text-sm md:text-base text-background-200/80 max-w-xl mx-auto">
              {category.description}
            </p>
          </div>
        </section>

        {/* Category articles */}
        <section className="px-4 md:px-6 py-10 md:py-16">
          <div className="max-w-7xl mx-auto">
            {topArticles.length > 0 && (
              <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 mb-10">
                {topArticles.map((article) => (
                  <Link
                    key={article.id}
                    to={`/article/${article.slug}`}
                    className="group relative aspect-[4/3] rounded-xl overflow-hidden cursor-pointer"
                  >
                    <img
                      src={articleImages[article.id] || articleImages['1']}
                      alt={article.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                      title={`${article.title} - 黑料在线`}
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/20 to-transparent"></div>
                    <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                      <h2 className="text-sm md:text-lg font-bold font-heading text-background-50 line-clamp-2">
                        {article.title}
                      </h2>
                      <div className="flex items-center gap-3 mt-2 text-xs text-background-200/80">
                        <span>{article.date}</span>
                        <span>{article.views > 10000 ? `${(article.views / 10000).toFixed(1)}万阅读` : `${article.views}阅读`}</span>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            )}

            <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950 mb-6">
              全部文章
            </h2>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {remainingArticles.map((article) => (
                <Link
                  key={article.id}
                  to={`/article/${article.slug}`}
                  className="group rounded-xl bg-background-50 overflow-hidden hover:bg-background-100 transition-colors cursor-pointer"
                >
                  <div className="aspect-[16/10] overflow-hidden">
                    <img
                      src={articleImages[article.id] || articleImages['1']}
                      alt={article.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                      title={`${article.title} - 黑料在线`}
                    />
                  </div>
                  <div className="p-4">
                    <h3 className="text-sm font-semibold font-heading text-foreground-900 line-clamp-2 mb-2 group-hover:text-accent-600 transition-colors">
                      {article.title}
                    </h3>
                    <p className="text-xs text-foreground-500 line-clamp-2 mb-3">
                      {article.excerpt}
                    </p>
                    <div className="flex items-center gap-3 text-xs text-foreground-500">
                      <span>{article.date}</span>
                      <span>{article.views > 10000 ? `${(article.views / 10000).toFixed(1)}万阅读` : `${article.views}阅读`}</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>

            {categoryArticles.length === 0 && (
              <div className="text-center py-16">
                <p className="text-foreground-500">暂无该分类的文章</p>
              </div>
            )}
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}